export interface IPurchaserConfigTemplate {
  configTemplateId: number;
  appPurchaserId: number;
  metadata: unknown;
  searchKeywords: string | null;
  intelligenceFilter: unknown;
  deductionTypeInvoicePatternForDiscount: unknown;
  additionalFieldMapping: unknown;
  discountTermAgreementDaysTolerance: number | null;
  isActive: boolean;
}

export class PurchaserConfigTemplate {
  private readonly _configTemplateId: number;
  private readonly _appPurchaserId: number;
  private readonly _metadata: unknown;
  private readonly _searchKeywords: string | null;
  private readonly _intelligenceFilter: unknown;
  private readonly _deductionTypeInvoicePatternForDiscount: unknown;
  private readonly _additionalFieldMapping: unknown;
  private readonly _discountTermAgreementDaysTolerance: number | null;
  private readonly _isActive: boolean;

  constructor(props: IPurchaserConfigTemplate) {
    this._configTemplateId = props.configTemplateId;
    this._appPurchaserId = props.appPurchaserId;
    this._metadata = props.metadata ?? null;
    this._searchKeywords = props.searchKeywords ?? null;
    this._intelligenceFilter = props.intelligenceFilter ?? null;
    this._deductionTypeInvoicePatternForDiscount =
      props.deductionTypeInvoicePatternForDiscount ?? null;
    this._additionalFieldMapping = props.additionalFieldMapping ?? null;
    this._discountTermAgreementDaysTolerance =
      props.discountTermAgreementDaysTolerance ?? null;
    this._isActive = props.isActive ?? true;
  }

  get configTemplateId(): number {
    return this._configTemplateId;
  }
  get appPurchaserId(): number {
    return this._appPurchaserId;
  }
  get metadata(): unknown {
    return this._metadata;
  }
  get searchKeywords(): string | null {
    return this._searchKeywords;
  }
  get intelligenceFilter(): unknown {
    return this._intelligenceFilter;
  }
  get deductionTypeInvoicePatternForDiscount(): unknown {
    return this._deductionTypeInvoicePatternForDiscount;
  }
  get additionalFieldMapping(): unknown {
    return this._additionalFieldMapping;
  }
  get discountTermAgreementDaysTolerance(): number | null {
    return this._discountTermAgreementDaysTolerance;
  }
  get isActive(): boolean {
    return this._isActive;
  }

  static from(props: IPurchaserConfigTemplate): PurchaserConfigTemplate {
    return new PurchaserConfigTemplate(props);
  }

  static toJSON(entity: PurchaserConfigTemplate): IPurchaserConfigTemplate {
    return {
      configTemplateId: entity.configTemplateId,
      appPurchaserId: entity.appPurchaserId,
      metadata: entity.metadata,
      searchKeywords: entity.searchKeywords,
      intelligenceFilter: entity.intelligenceFilter,
      deductionTypeInvoicePatternForDiscount:
        entity.deductionTypeInvoicePatternForDiscount,
      additionalFieldMapping: entity.additionalFieldMapping,
      discountTermAgreementDaysTolerance:
        entity.discountTermAgreementDaysTolerance,
      isActive: entity.isActive,
    };
  }
}
